module.exports = __webpack_public_path__ + "img/wallet_app_icon.78745230.png";